var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPediatrics = function SvgPediatrics(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-14 -10 90.1 93.1",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".pediatrics{fill:#f9f9fa;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pediatrics",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pediatrics",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pediatrics"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "pediatrics",
    cx: 40.5,
    cy: 35.6,
    rx: 1.5,
    ry: 1.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "pediatrics",
    cx: 24.5,
    cy: 35.6,
    rx: 1.5,
    ry: 1.7
  }), /*#__PURE__*/React.createElement("g", {
    id: "pediatrics",
    "data-name": "baby boy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "pediatrics",
    d: "M32.5,63.1a25.53,25.53,0,0,1-24.4-18,8.5,8.5,0,0,1,.4-17h1.8a1.5,1.5,0,1,1,0,3H8.5a5.5,5.5,0,0,0,0,11h.8a1.63,1.63,0,0,1,1.5,1.1,22.45,22.45,0,0,0,43.5,0,1.5,1.5,0,0,1,1.5-1.1h.8a5.5,5.5,0,0,0,0-11H54.5a1.5,1.5,0,0,1,0-3h2.1a8.5,8.5,0,0,1,.4,17A25.78,25.78,0,0,1,32.5,63.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pediatrics",
    d: "M55.2,31.1a1.5,1.5,0,0,1-1.4-1A22.67,22.67,0,0,0,40.1,16.4a1.49,1.49,0,1,1,1-2.8A25.9,25.9,0,0,1,56.7,29.2a1.41,1.41,0,0,1-.9,1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pediatrics",
    d: "M24.5,38.1A2.5,2.5,0,1,1,27,35.6,2.48,2.48,0,0,1,24.5,38.1Zm0-3.1a.5.5,0,1,0,.5.5A.47.47,0,0,0,24.5,35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pediatrics",
    d: "M40.5,38.1A2.5,2.5,0,1,1,43,35.6,2.48,2.48,0,0,1,40.5,38.1Zm0-3.1a.5.5,0,1,0,.5.5A.47.47,0,0,0,40.5,35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pediatrics",
    d: "M32.8,51.9a14.63,14.63,0,0,1-7.1-2,1.51,1.51,0,1,1,1.7-2.5h0c.2.1,5.3,3.4,10.3,0a1.51,1.51,0,1,1,1.7,2.5A11.94,11.94,0,0,1,32.8,51.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pediatrics",
    d: "M9.9,31.1a.9.9,0,0,1-.5-.1,1.45,1.45,0,0,1-.9-1.9,25.58,25.58,0,0,1,21-16.8A7.21,7.21,0,0,0,33,10.9c2-1.4,2.9-2.9,2.9-4.5a3.27,3.27,0,0,0-3.3-3.3,2.36,2.36,0,0,0-1.6.7,2.19,2.19,0,0,0-.7,1.9,1.55,1.55,0,0,0,.8,1.1,1.44,1.44,0,0,1,.7,2,1.44,1.44,0,0,1-2,.7,4.51,4.51,0,0,1-2.5-3.3,5.15,5.15,0,0,1,1.4-4.5A5.17,5.17,0,0,1,32.5,0a6.34,6.34,0,0,1,6.3,6.3c.1,2.7-1.3,5-4.2,7a10.5,10.5,0,0,1-4.9,1.9A22.55,22.55,0,0,0,11.2,30,1.29,1.29,0,0,1,9.9,31.1Z"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPediatrics, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pediatrics.4e3babce.svg";
export { ForwardRef as ReactComponent };